export default {
    auth_request(state) {
        state.status = 'loading';
    },
    auth_success(state, payload) {
        state.status = 'success';
        state.userInfo = payload.userInfo;
    },
    auth_error(state) {
        state.status = 'error';
        state.token = '';
        state.userInfo = null;
    },
    logout(state) {
        state.status = '';
        state.token = '';
    },
    auth_loading(state, loading) {
        state.loading = loading;
    },
    setEmail(state, email) {
        state.emailForgot = email;
    },
    profile_member(state, payload) {
        state.userInfo.avatar_url = payload.avatar_url;
        state.userInfo.email = payload.email;
        state.userInfo.name = payload.name;
        state.userInfo.surname = payload.surname;
    }
};
